module.exports = __webpack_public_path__ + "static/media/A.cd7f7901.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Talk/A.png
// module id = 1226
// module chunks = 2